import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function PencilIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 32 32'} fontSize={'inherit'} {...props}>
      <path d="M31.015 3.706l-2.717-2.72c-0.61-0.608-1.451-0.985-2.38-0.985s-1.771 0.376-2.38 0.985l-21.754 21.754c-0.195 0.195-0.334 0.446-0.392 0.726l-0.002 0.009-1.362 6.8c-0.018 0.085-0.028 0.183-0.028 0.283 0 0.797 0.646 1.443 1.443 1.443 0.1 0 0.198-0.010 0.292-0.030l-0.009 0.002 6.8-1.359c0.29-0.059 0.541-0.199 0.736-0.394v0l21.755-21.755c0.608-0.609 0.985-1.451 0.985-2.38s-0.376-1.771-0.985-2.38l0 0zM7.53 27.871l-4.25 0.852 0.849-4.25 17.708-17.695 3.401 3.385zM28.975 6.427l-1.701 1.701-3.395-3.401 1.698-1.701c0.087-0.087 0.207-0.141 0.34-0.141s0.253 0.054 0.34 0.141v0l2.721 2.721c0.087 0.087 0.141 0.207 0.141 0.34s-0.054 0.253-0.141 0.34v0z"></path>
    </SvgIcon>
  );
}
